import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './RatingBar.scss';

class RatingBar extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
    /** max number of bars to represent. */
    max: PropTypes.number,
    /** current number of bars. Can be floating point. */
    current: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /** label of bar */
    label: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    max: 5,
    current: 0,
  };

  renderBars(converted) {
    const { max } = this.props;
    const bars = [];
    for (let i = 0; i < max; i++) {
      let className;
      if (i < Math.floor(converted)) {
        className = 'common-rating-bar__bar--filled';
      } else if (i >= Math.ceil(converted)) {
        className = 'common-rating-bar__bar--empty';
      } else {
        className = 'common-rating-bar__bar--half';
      }

      bars.push(
        <div
          key={i}
          className={classnames('common-rating-bar__bar', className)}
        />
      );
    }
    return bars;
  }

  render() {
    const { className, current, label } = this.props;

    if (!current) {
      return null;
    }

    const converted = parseFloat(current).toFixed(1);

    if (converted < 0) {
      return null;
    }

    return (
      <div className={classnames('common-rating-bar', className)}>
        <div className="common-rating-bar__label">{label}</div>
        <div className="common-rating-bar__bars">
          {this.renderBars(converted)}
        </div>
      </div>
    );
  }
}

export default RatingBar;



// WEBPACK FOOTER //
// ./src/components/common/rating-bar/RatingBar.js